import { render, staticRenderFns } from "./activity-detail.vue?vue&type=template&id=bb3fd19a&"
import script from "./activity-detail.vue?vue&type=script&lang=js&"
export * from "./activity-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports